import e from "./ScreenReader.vue_vue_type_script_setup_true_lang.js";
//#region src/shared/ScreenReader.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ScreenReader.vue.js.map